export default __webpack_public_path__ + "static/media/facility-info-icon.f8e79be2.svg";